import { render, staticRenderFns } from "./TranshipmentTariffFormDialog.vue?vue&type=template&id=1fc26206&scoped=true"
import script from "./TranshipmentTariffFormDialog.vue?vue&type=script&lang=js"
export * from "./TranshipmentTariffFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentTariffFormDialog.vue?vue&type=style&index=0&id=1fc26206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc26206",
  null
  
)

export default component.exports